"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.initialState = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _marketplace = require("./marketplace.types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isLoading: false,
  exchangeLoading: false,
  convertedPrice: null,
  convertedPrices: null,
  rangeDenominationValue: null,

  /**
   * Country id of recipient by which marketplace products will be requested.
   *
   * @type {?number} - Recipient country id.
   */
  countryId: null,
  product: null,
  products: [],
  pagination: {
    current_page: 0,
    per_page: 9,
    total: null,
    total_pages: null
  },
  filters: {
    categories: [],
    types: []
  },
  error: null
};
exports.initialState = initialState;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filters: action.payload
        });
      }

    case _marketplace.GIFT_CREATE_MARKETPLACE_CLEAR_PRODUCTS:
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), initialState), {}, {
          filters: state.filters,
          countryId: state.countryId
        });
      }

    case _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_REQUEST:
    case _marketplace.GIFT_CREATE_LOAD_PRODUCT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        products: parseInt(action.payload.meta.pagination.current_page, 10) === 1 ? action.payload.products : [].concat((0, _toConsumableArray2.default)(state.products), (0, _toConsumableArray2.default)(action.payload.products)),
        pagination: _objectSpread(_objectSpread({}, action.payload.meta.pagination), {}, {
          per_page: parseInt(action.payload.meta.pagination.per_page, 10)
        }),
        isLoading: false
      });

    case _marketplace.GIFT_CREATE_LOAD_PRODUCT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        product: action.payload,
        isLoading: false
      });

    case _marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_FAIL:
    case _marketplace.GIFT_CREATE_LOAD_PRODUCT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        isLoading: true
      });

    case _marketplace.GIFT_CREATE_MARKETPLACE_SET_COUNTRY_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        countryId: action.payload
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        exchangeLoading: true
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        convertedPrice: action.payload,
        exchangeLoading: false
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        exchangeLoading: false
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        exchangeLoading: true
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        convertedPrices: action.payload,
        exchangeLoading: false
      });

    case _marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        exchangeLoading: false
      });

    case _marketplace.GIFT_SET_RANGED_PRODUCT_PRICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        rangeDenominationValue: action.payload
      });

    default:
      return state;
  }
};

exports.reducer = reducer;